import React from "react"
import Combobox from "@shared/combobox"
import { getRequest } from '@react/helpers/fetch'

export const fetchClient = (clientId, state, setState) => {
  getRequest(`/clients/${clientId}/build.json`)
  .then(client => {
    const asset = {
      id:   client.id,
      type: "client",
      name: I18n.t("sites.site")
    }
    setState(prevState => ({ ...prevState, filter: { ...state.filter, client, asset } }))
  })
}

export const selectSite = (siteId, state, setState) => {
  const site   = state.filter.client.sites.find(s => s.id == siteId)
  const asset = {
    id:   site.id,
    type: "site",
    name: I18n.t("materials.title"),
  }
  setState(prevState => ({ ...prevState, filter: { ...state.filter, site, asset } }))
}

export const AssetFilter = ({ state, setState }) => {
  const filter = state.filter

  const resetClient = () => {
    delete filter.client
    delete filter.site
    delete filter.asset

    setState(prevState => ({ ...prevState, filter: { ...filter } }))
  }

  const resetSite = () => {
    delete filter.site

    const asset = {
      name: I18n.t("sites.site"),
      type: "client",
      id:   filter.client.id
    }
    setState(prevState => ({ ...prevState, filter: { ...filter, asset } }))
  }

  return (
    <>
      <div className="form-group">
        <Combobox
          feed             = "/clients/autocomplete.json"
          prompt           = {I18n.t("operational_costs.all_clients")}
          onSelectElement  = {client => fetchClient(client.id, state, setState)}
          onReset          = {resetClient}
          options          = {filter.client ? [filter.client] : []}
          value            = {filter.client?.id}
          resetIcon
        />
      </div>

      <div className="form-group">
        <Combobox
          prompt          = {I18n.t("operational_costs.all_sites") }
          options         = {filter.client?.sites || [] }
          onReset         = {resetSite }
          onSelectElement = {site => selectSite(site.id, state, setState) }
          value           = {filter.site?.id}
          resetIcon
        />
      </div>
    </>
  )
}
